import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoDeferredErrorVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoDeferredErrorVO.validationSchema()
  );

  constructor(readonly value: RoomBrandLogoDeferredError) {
    JsonSchemaValidator.assert(RoomBrandLogoDeferredErrorVO.validation, value);
  }

  toString() {
    return `${this.value.message} (${this.value.code}, ${this.value.errorId})`;
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["code", "message"],
      properties: {
        code: {
          type: "number",
          minimum: 0,
          maximum: Number.MAX_SAFE_INTEGER
        },
        message: {
          type: "string",
          minLength: 0,
          maxLength: 2_048
        },
        errorId: {
          type: "string",
          format: "uuid"
        }
      }
    };
  }
}

interface RoomBrandLogoDeferredError {
  code: number;
  message: string;
  errorId?: string;
}
